import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {Region, StateUtils} from '@spartacus/core';
import {LoaderState} from '../../../state/utils/loader/loader-state';
import {StateWithUserRegionState, USER_REGION_ZONE, UserRegionState} from '../reducers/regions-zone.reducer';

export interface RegionsState {
  entities: Region[];
  country: string;
  zone: string;
}

export const getUserRegionState: MemoizedSelector<StateWithUserRegionState, UserRegionState> =
  createFeatureSelector<UserRegionState>(USER_REGION_ZONE);

export const getRegionsLoaderState: MemoizedSelector<
  StateWithUserRegionState,
  LoaderState<RegionsState>
> = createSelector(getUserRegionState, (state: UserRegionState) => state.regions);

export const getAllRegions: MemoizedSelector<
  StateWithUserRegionState,
  Region[]
> = createSelector(
  getRegionsLoaderState,
  (state: LoaderState<RegionsState>) => {
    return StateUtils.loaderValueSelector(state).entities;
  }
);

export const getRegionsDataAndLoading: MemoizedSelector<
  StateWithUserRegionState,
  {
    loaded: boolean;
    loading: boolean;
    regions: Region[];
    country: string;
    zone: string;
  }
> = createSelector(
  getRegionsLoaderState,
  (state: LoaderState<RegionsState>) => ({
    loaded: StateUtils.loaderSuccessSelector(state),
    loading: StateUtils.loaderLoadingSelector(state),
    regions: StateUtils.loaderValueSelector(state).entities,
    country: StateUtils.loaderValueSelector(state).country,
    zone: StateUtils.loaderValueSelector(state).zone,
  })
);

export const getRegionsCountry: MemoizedSelector<
  StateWithUserRegionState,
  string
> = createSelector(
  getRegionsLoaderState,
  (state: LoaderState<RegionsState>) =>
    StateUtils.loaderValueSelector(state).country
);

export const getRegionsLoading: MemoizedSelector<
  StateWithUserRegionState,
  boolean
> = createSelector(getRegionsLoaderState, (state: LoaderState<RegionsState>) =>
  StateUtils.loaderLoadingSelector(state)
);

export const getRegionsLoaded: MemoizedSelector<
  StateWithUserRegionState,
  boolean
> = createSelector(getRegionsLoaderState, (state: LoaderState<RegionsState>) =>
  StateUtils.loaderSuccessSelector(state)
);
